import { useEffect } from 'react'

import { useBridge } from '../bridge'
import { detectWebView } from './detectWebView'

interface WebViewGuardProps {
  fallbackUrl: string
  children: React.ReactNode
}

/**
 * 프로덕션에서 일반 브라우저 접근을 차단한다(UA + Bridge 이중 체크).
 * 개발 환경에서는 체크를 스킵해 로컬 브라우저 디버깅을 허용한다.
 */
export function WebViewGuard({ fallbackUrl, children }: WebViewGuardProps) {
  const { isTimeout } = useBridge()
  const isDev = import.meta.env.DEV
  const shouldRedirect = !isDev && (!detectWebView() || isTimeout)

  useEffect(() => {
    if (!shouldRedirect) return
    const reason = isTimeout ? 'bridge-timeout' : 'ua-mismatch'
    console.error('[WebViewGuard] blocked', { reason })
    window.location.href = fallbackUrl
  }, [shouldRedirect, fallbackUrl, isTimeout])

  if (shouldRedirect) return null
  return <>{children}</>
}
